import { render, staticRenderFns } from "./NeedsUpdatesAIItem.vue?vue&type=template&id=629bf3b0&scoped=true&"
import script from "./NeedsUpdatesAIItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsUpdatesAIItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629bf3b0",
  null
  
)

export default component.exports